import {
  Actions,
  Box,
  Button,
  Heading,
  Stack,
  Text,
} from 'braid-design-system';

import AddUsersIcon from '../../icons/AddUsersIcon';
import { useTranslations } from '@vocab/react';
import translations from '../.vocab';
interface Props {
  onClick: () => void;
}

export const JobIsExpiredView = ({ onClick }: Props) => {
  const { t } = useTranslations(translations);
  return (
    <Box display="flex" justifyContent="center" marginY="xlarge">
      <Box textAlign="center" maxWidth="small">
        <Stack space="large">
          <Box>
            <AddUsersIcon />
          </Box>
          <Heading level="4">{t('This job is expired')}</Heading>
          <Text tone="secondary">{t('This job is no longer live....')}</Text>
          <Box display="flex" justifyContent="center">
            <Actions>
              <Button onClick={onClick}>{t('Return to job')}</Button>
            </Actions>
          </Box>
        </Stack>
      </Box>
    </Box>
  );
};
